<template>
  <div v-if="imDialogVisible">
    <div class="iconChatBox">
      <div class="img flex-dc-rc">
        <div class="vip-window" @click.stop v-if="!isBusiness">
          <img src="../../assets/images/pop/vip/vip-new-button.png" @click="goVip"/>
        </div>
        <div class="business-window" @click.stop v-else>
          <div class="right-top-close" @click="closeWindow"></div>
          <div class="bottom-go-vip" @click="goVip"></div>
        </div>
        <img class="close-btn" src="../../assets/images/pop/publish/publish-pop-close.png" v-if="!isBusiness"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { routerWindow } from "@/utils/tool";
import { G60site } from "@/router/index";


export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['imDialogVisible']),
    isBusiness(){
      return this.$route.path === '/business-vip' || this.$route.query.fromBusiness === '1'
    },
  },
  methods: {
    closeWindow(){
      this.$store.commit('message/SET_IM_WINDOW_DIALOG', false)
    },
    goVip () {
      this.$store.commit('message/SET_IM_WINDOW_DIALOG', false)
      if(this.isBusiness){
        this.$router.push({
          path: '/business-vip',
          query:{
            channel: -2,
            offset: 1,
          }
        })
        return
      }
      else if(G60site){
        this.$router.push({
          path: '/vip',
          query:{
          }
        })
        return
      }
      routerWindow(this.$router,'/vip',{setType:2})
    }
  }
}
</script>


<style scoped lang="scss">
.iconChatBox {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  z-index: 999;
  position: absolute;
  top: 0%;
  overflow: auto;
  .img {
    padding-top: 100px;
    .business-window{
      width: 292px;
      height: 322px;
      background-image: url('../../assets/images/business-vip/business-top.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      .right-top-close{
        width: 30px;
        height: 28px;
        position: absolute;
        top: 10px;
        right: 12px;
        cursor: pointer;
      }
      .bottom-go-vip{
        width: 250px;
        height: 48px;
        position: absolute;
        bottom: 25px;
        left: 50%;
        margin-left: -125px;
        cursor: pointer;
      }
    }
    .vip-window{
      width: 304px;
      height: 313px;
      background-image: url('../../assets/images/pop/vip/vip-new.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      img{
        position: absolute;
        bottom: 20px;
        width: 198px;
        height: 44px;
        cursor: pointer;
        left: 50%;
        margin-left: -99px;
      }
    }
    .close-btn{
      color: #ffffff;
      font-size: 50px;
      cursor: pointer;
      display: grid;
      text-align: center;
      margin-top: 36px;
      width: 31px;
      height: 31px;
    }
  }
}
</style>